module.exports = __webpack_public_path__ + "static/26-01f4875f6fb906a22c5499516d9728e7.png";